<template>
  <div class="cardFooterDetails">
    <div
      v-if="fuelMeter.measurementUnit || density"
      class="pulseInfo"
    >
      <div>
        {{ $t(`massBalance.e4Form.labels.unit`) }} : {{ measurementUnit }}
      </div>
      <div
        v-if="density"
      >
        {{ $t(`forms.labels.density`) }} : {{ density }}
      </div>
    </div>
  </div>
</template>

<script>
export default {

    props: {
        fuelMeter: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        measurementUnit() {
            return this?.fuelMeter?.measurementUnit ? this.$t(`massBalance.e4Form.units.${this?.fuelMeter?.measurementUnit}`) : '';
        },
        density() {
            if (this.fuelMeter?.density && this.fuelMeter?.density?.value && this.fuelMeter?.density?.unit) {
                return `${this.fuelMeter.density.value} ${this.fuelMeter.density.unit}`;
            }
            return '';
        },
    },
};
</script>
<style scoped lang="scss">
@import '@/assets/styles/components/_analysisGrid.scss';
.pulseInfo {
    display: flex;
    justify-content: space-between;
  }
</style>
